import React, { useLayoutEffect, useRef, useState } from 'react';
import { FaFileAlt } from 'react-icons/fa';
import './print-preview.css';

export default function PrintPreview({ children }) {
    const viewport = useRef(null);
    const content = useRef(null);
    const [size, setSize] = useState({ scale: 1, height: 0 });
    useLayoutEffect(() => {
        let frame;
        const measure = () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => {
                if (!viewport.current || !content.current) return;
                const scale = Math.min(1, Math.max(0.15, (viewport.current.clientWidth - 24) / 792));
                const height = content.current.offsetHeight;
                setSize(previous => Math.abs(previous.scale - scale) < 0.001 && previous.height === height ? previous : { scale, height });
            });
        };
        const observer = new ResizeObserver(measure);
        observer.observe(viewport.current); observer.observe(content.current);
        measure();
        return () => { observer.disconnect(); cancelAnimationFrame(frame); };
    }, []);
    return <section className="diagramacao-preview-surface">
        <div className="diagramacao-preview-caption hidethis"><FaFileAlt /><div><h5>Prévia para impressão</h5><p>A visualização se ajusta à tela. O arquivo mantém o tamanho A4.</p></div></div>
        <div className="diagramacao-preview-viewport" ref={viewport}><div className="diagramacao-preview-dimensions" style={{ width: 792 * size.scale, height: size.height ? size.height * size.scale : 'auto' }}>
            <div className="diagramacao-preview-content" ref={content} style={{ width: 792, transform: `scale(${size.scale})` }}>{children}</div>
        </div></div>
    </section>;
}
